document.addEventListener('DOMContentLoaded', function() {
  // Configuration
  const config = {
    isMobile: window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
    zoomContainer: null,
    processedImages: new Set(),
    zoomIcons: new Set(),
    zoomLenses: new Set(),
    driftInstances: new Map(),
    mobileLensSize: 200,
    desktopZoomFactor: 2,
    // New: Image preloading cache
    imageCache: new Map(),
    preloadedImages: new Set()
  };

  // Preload high-res images
  function preloadHighResImage(img) {
    const zoomSrc = getHighResSrc(img);
    if (!zoomSrc || config.preloadedImages.has(zoomSrc)) return Promise.resolve();
    
    return new Promise((resolve) => {
      const preloadImg = new Image();
      preloadImg.onload = () => {
        config.imageCache.set(zoomSrc, preloadImg);
        config.preloadedImages.add(zoomSrc);
        resolve();
      };
      preloadImg.onerror = () => resolve(); // Continue even if preload fails
      preloadImg.src = zoomSrc;
    });
  }

  // Initialize zoom container
  function initZoomContainer() {
    if (!config.zoomContainer) {
      config.zoomContainer = document.createElement('div');
      config.zoomContainer.className = 'drift-zoom-container';
      config.zoomContainer.style.cssText = `
        position: absolute; left: 46%; top: 40%; width: 25%; height: 50%;
        background: #fff; border: 2px solid #fff; border-radius: 8px;
        z-index: 1; display: none; box-shadow: 0 4px 12px #fff;
      `;
      document.body.appendChild(config.zoomContainer);
    }
  }

  // Create mobile zoom elements with instant zoom
  function createMobileZoomElements(img) {
    const zoomIcon = document.createElement('div');
    zoomIcon.innerHTML = `<svg
      aria-hidden="true"
      focusable="false"
      class="icon icon-plus"
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M4.66724 7.93978C4.66655 7.66364 4.88984 7.43922 5.16598 7.43853L10.6996 7.42464C10.9758 7.42395 11.2002 7.64724 11.2009 7.92339C11.2016 8.19953 10.9783 8.42395 10.7021 8.42464L5.16849 8.43852C4.89235 8.43922 4.66793 8.21592 4.66724 7.93978Z" fill="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.92576 4.66463C8.2019 4.66394 8.42632 4.88723 8.42702 5.16337L8.4409 10.697C8.44159 10.9732 8.2183 11.1976 7.94215 11.1983C7.66601 11.199 7.44159 10.9757 7.4409 10.6995L7.42702 5.16588C7.42633 4.88974 7.64962 4.66532 7.92576 4.66463Z" fill="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12.8324 3.03011C10.1255 0.323296 5.73693 0.323296 3.03011 3.03011C0.323296 5.73693 0.323296 10.1256 3.03011 12.8324C5.73693 15.5392 10.1255 15.5392 12.8324 12.8324C15.5392 10.1256 15.5392 5.73693 12.8324 3.03011ZM2.32301 2.32301C5.42035 -0.774336 10.4421 -0.774336 13.5395 2.32301C16.6101 5.39361 16.6366 10.3556 13.619 13.4588L18.2473 18.0871C18.4426 18.2824 18.4426 18.599 18.2473 18.7943C18.0521 18.9895 17.7355 18.9895 17.5402 18.7943L12.8778 14.1318C9.76383 16.6223 5.20839 16.4249 2.32301 13.5395C-0.774335 10.4421 -0.774335 5.42035 2.32301 2.32301Z" fill="currentColor"/>
    </svg>`;
    zoomIcon.style.cssText = `
      position: absolute; top: 13px; left: 5px; width: 40px; height: 40px;background:white;
      border: 1px solid #ddd; border-radius: 50%; display: flex;
      align-items: center; justify-content: center; cursor: pointer;
      font-size: 18px; z-index: 1; box-shadow: 0 2px 8px rgba(0,0,0,0.2);
      transition: all 0.2s ease; pointer-events: auto; user-select: none;
    `;

    const imgContainer = img.parentElement;
    if (!imgContainer) return;

    const computedStyle = window.getComputedStyle(imgContainer);
    if (computedStyle.position === 'static') imgContainer.style.position = 'relative';
    
    imgContainer.appendChild(zoomIcon);
    config.zoomIcons.add(zoomIcon);

    const zoomLens = createZoomLens();
    const zoomSrc = getHighResSrc(img);
    let isDragging = false;

    // Preload the high-res image immediately
    preloadHighResImage(img);

    // Event handlers with instant response
    const handleStart = (clientX, clientY) => {
      isDragging = true;
      zoomLens.style.display = 'block';
      
      // Use cached image if available, otherwise use original img as fallback
      const cachedImg = config.imageCache.get(zoomSrc);
      if (cachedImg) {
        zoomLens.style.backgroundImage = `url(${zoomSrc})`;
      } else {
        // Use original image temporarily to avoid white flash
        zoomLens.style.backgroundImage = `url(${img.src})`;
        // Try to load high-res in background
        preloadHighResImage(img).then(() => {
          if (isDragging) {
            zoomLens.style.backgroundImage = `url(${zoomSrc})`;
          }
        });
      }
      
      updateZoomLens(clientX, clientY, img, zoomLens);
      zoomIcon.style.transform = 'scale(1.1)';
    };

    const handleMove = (clientX, clientY) => {
      if (!isDragging) return;
      updateZoomLens(clientX, clientY, img, zoomLens);
    };

    const handleEnd = () => {
      isDragging = false;
      zoomLens.style.display = 'none';
      zoomIcon.style.transform = 'scale(1)';
    };

    // Touch events with immediate response
    zoomIcon.addEventListener('touchstart', (e) => {
      e.preventDefault();
      handleStart(e.touches[0].clientX, e.touches[0].clientY);
    }, { passive: false });

    zoomIcon.addEventListener('touchmove', (e) => {
      e.preventDefault();
      handleMove(e.touches[0].clientX, e.touches[0].clientY);
    }, { passive: false });

    zoomIcon.addEventListener('touchend', (e) => {
      e.preventDefault();
      handleEnd();
    }, { passive: false });

    // Mouse events
    zoomIcon.addEventListener('mousedown', (e) => {
      e.preventDefault();
      handleStart(e.clientX, e.clientY);
    });

    document.addEventListener('mousemove', (e) => handleMove(e.clientX, e.clientY));
    document.addEventListener('mouseup', handleEnd);

    return zoomIcon;
  }

  function createZoomLens() {
    const lens = document.createElement('div');
    lens.className = 'mobile-zoom-lens';
    lens.style.cssText = `
      position: fixed; width: ${config.mobileLensSize}px;
      height: ${config.mobileLensSize}px; border: 3px solid #fff;
      border-radius: 50%; background: #f0f0f0; box-shadow: 0 4px 15px #fff;
      z-index: 1; display: none; overflow: hidden; pointer-events: none;
      background-size: cover; background-repeat: no-repeat;
      transition: none; /* Remove transitions for instant response */
    `;
    document.body.appendChild(lens);
    config.zoomLenses.add(lens);
    return lens;
  }

  // Optimized zoom lens update with requestAnimationFrame
  let animationFrameId;
  function updateZoomLens(x, y, img, lens) {
    if (animationFrameId) {
      cancelAnimationFrame(animationFrameId);
    }
    
    animationFrameId = requestAnimationFrame(() => {
      const imgRect = img.getBoundingClientRect();
      lens.style.left = (x - config.mobileLensSize / 2) + 'px';
      lens.style.top = (y - config.mobileLensSize / 2) + 'px';
      
      const relativeX = Math.max(0, Math.min(1, (x - imgRect.left) / imgRect.width));
      const relativeY = Math.max(0, Math.min(1, (y - imgRect.top) / imgRect.height));
      
      lens.style.backgroundPosition = `${relativeX * 100}% ${relativeY * 100}%`;
      lens.style.backgroundSize = `${imgRect.width * 3}px ${imgRect.height * 3}px`;
      lens.style.borderColor = '#fff';
    });
  }

  function getHighResSrc(img) {
    let src = img.src || img.getAttribute('data-src') || img.getAttribute('srcset');
    // Optimize resolution based on screen size
    const screenWidth = window.innerWidth;
    const targetWidth = screenWidth > 1920 ? 2000 : screenWidth > 1200 ? 1500 : 1200;
    return src.includes('cdn/shop') ? src.split('?')[0] + `?width=${targetWidth}` : src;
  }

  function isProductImage(img) {
    const imgSrc = img.src || img.getAttribute('data-src') || img.getAttribute('srcset');
    if (!imgSrc || !imgSrc.includes('cdn/shop')) return false;

    let parent = img.parentElement;
    for (let depth = 0; depth < 5 && parent; depth++) {
      const className = parent.className || '';
      const tagName = parent.tagName.toLowerCase();
      
      if (className.includes('product') && 
          (className.includes('media') || className.includes('image') || 
           className.includes('gallery') || className.includes('photo'))) {
        return true;
      }
      
      if (className.includes('product-media') || className.includes('product__media') ||
          className.includes('product-gallery') || className.includes('product-image') ||
          className.includes('product-photos') || tagName === 'modal-opener') {
        return true;
      }
      
      if (className.includes('header') || className.includes('footer') ||
          className.includes('nav') || className.includes('menu') ||
          className.includes('logo') || className.includes('icon') ||
          className.includes('banner') || className.includes('hero') ||
          className.includes('cart') || className.includes('checkout')) {
        return false;
      }
      
      parent = parent.parentElement;
    }

    const isProductPage = window.location.pathname.includes('/products/') ||
                         document.querySelector('.product-form') ||
                         document.querySelector('[data-product-id]') ||
                         document.querySelector('.product-details');
    
    if (isProductPage) {
      const rect = img.getBoundingClientRect();
      if (rect.width > 200 && rect.height > 200) {
        const bodyRect = document.body.getBoundingClientRect();
        const relativeY = (rect.top - bodyRect.top) / bodyRect.height;
        return relativeY > 0.15 && relativeY < 0.85;
      }
    }
    
    return false;
  }

  function cleanupMobileElements() {
    config.zoomIcons.forEach(icon => icon.parentNode?.removeChild(icon));
    config.zoomLenses.forEach(lens => lens.parentNode?.removeChild(lens));
    config.zoomIcons.clear();
    config.zoomLenses.clear();
  }

  function cleanupDesktopElements() {
    config.driftInstances.forEach(drift => drift.destroy());
    config.driftInstances.clear();
    config.zoomContainer?.parentNode?.removeChild(config.zoomContainer);
    config.zoomContainer = null;
  }

  function initDesktopZoom(img) {
    if (typeof Drift === 'undefined') return;
    
    if (config.driftInstances.has(img)) {
      config.driftInstances.get(img).destroy();
      config.driftInstances.delete(img);
    }

    const zoomSrc = getHighResSrc(img);
    if (!zoomSrc) return;

    // Preload high-res image for desktop too
    preloadHighResImage(img);

    img.setAttribute('data-zoom', zoomSrc);
    const drift = new Drift(img, {
      paneContainer: config.zoomContainer,
      inlinePane: false,
      hoverBoundingBox: true,
      sourceAttribute: 'data-zoom',
      zoomFactor: config.desktopZoomFactor,
      containInline: false,
      hoverDelay: 100, // Reduced from 200
      touchDelay: 150, // Reduced from 300
      onShow: () => config.zoomContainer.style.display = 'block',
      onHide: () => config.zoomContainer.style.display = 'none'
    });

    config.driftInstances.set(img, drift);
    img.style.cursor = 'zoom-in';
    img.title = 'Hover to zoom';
  }

  // Optimized image processing with batch preloading
  function processImage(img, index) {
    if (!img.src || config.processedImages.has(img)) return;
    if (!isProductImage(img) || img.offsetWidth < 100 || img.offsetHeight < 100) return;

    config.processedImages.add(img);

    try {
      if (config.isMobile) {
        config.driftInstances.get(img)?.destroy();
        config.driftInstances.delete(img);
        createMobileZoomElements(img);
        img.style.pointerEvents = 'none';
        img.style.cursor = 'default';
        img.title = 'Drag zoom icon to zoom';
        ['mouseenter', 'mouseleave', 'mousemove', 'touchstart', 'touchmove', 'touchend'].forEach(
          event => img.addEventListener(event, e => e.stopPropagation(), true)
        );
      } else {
        initDesktopZoom(img);
      }
    } catch (error) {
      console.error(`Zoom initialization failed for image ${index}:`, error);
    }
  }

  // Batch process images for better performance
  function findAndProcessImages() {
    const images = document.querySelectorAll('.product-media img, .product__media img');
    
    // Process images in batches to avoid blocking
    const batchSize = 3;
    let currentBatch = 0;
    
    function processBatch() {
      const start = currentBatch * batchSize;
      const end = Math.min(start + batchSize, images.length);
      
      for (let i = start; i < end; i++) {
        processImage(images[i], i);
      }
      
      currentBatch++;
      if (currentBatch * batchSize < images.length) {
        setTimeout(processBatch, 50); // Small delay between batches
      }
    }
    
    processBatch();
  }

  function reinitializeForDeviceChange() {
    config.processedImages.clear();
    if (config.isMobile) {
      cleanupDesktopElements();
    } else {
      cleanupMobileElements();
      initZoomContainer();
    }
    findAndProcessImages();
  }

  // Initialization
  function init() {
    if (!config.isMobile && typeof Drift === 'undefined') {
      console.error('Drift library not found!');
      return;
    }
    if (!config.isMobile) initZoomContainer();
    
    // Start processing images immediately
    findAndProcessImages();
  }

  // Event listeners
  window.addEventListener('orientationchange', () => {
    setTimeout(() => {
      const newIsMobile = window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      if (newIsMobile !== config.isMobile) {
        config.isMobile = newIsMobile;
        reinitializeForDeviceChange();
      }
    }, 100);
  });

  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      const newIsMobile = window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      if (newIsMobile !== config.isMobile) {
        config.isMobile = newIsMobile;
        reinitializeForDeviceChange();
      }
    }, 200);
  });

  // Optimized mutation observer
  const observer = new MutationObserver(mutations => {
    const imagesToProcess = [];
    
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          const newImages = node.tagName === 'IMG' ? [node] : Array.from(node.querySelectorAll('.product-media img, .product__media img'));
          imagesToProcess.push(...newImages);
        }
      });
      
      if (mutation.type === 'attributes' && 
          (mutation.attributeName === 'src' || mutation.attributeName === 'data-src') &&
          mutation.target.tagName === 'IMG') {
        imagesToProcess.push(mutation.target);
      }
    });
    
    // Process all images at once
    if (imagesToProcess.length > 0) {
      setTimeout(() => {
        imagesToProcess.forEach((img, index) => processImage(img, `dynamic-${index}`));
      }, 100);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['src', 'data-src', 'class']
  });

  document.addEventListener('load', e => {
    if (e.target.tagName === 'IMG') setTimeout(() => processImage(e.target, 'loaded'), 50);
  }, true);

  // Reduced scroll processing frequency
  let scrollTimeout;
  window.addEventListener('scroll', () => {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(findAndProcessImages, 2000); // Increased from 1000
  });

  // Reduced interval frequency
  setInterval(findAndProcessImages, 5000); // Increased from 3000
  
  init();
});